import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilCreateDashboard, UilCircle, UilShield } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const getInvestorMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  const { investorId } = useSelector((state) => state.auth);

  return [
    {
      key: 'starter',
      label: (
        <NavLink onClick={toggleCollapsed} to={`${basePath}/pages/starter`}>
          {t('SPMU')} {t('Investor')} {t('Home')}
        </NavLink>
      ),
      icon: !topMenu && <UilCircle />,
    },
    {
      key: 'Projects',
      label: t('Projects'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'My Projects',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/projects/view`}>
              {t('Projects Invested')}
            </NavLink>
          ),
        },
        {
          key: 'All Projects',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/projects/all`}>
              {t('All Projects')}
            </NavLink>
          ),
        },
        // {
        //   key: 'New Projects',
        //   label: (
        //     <NavLink onClick={toggleCollapsed} to={`${basePath}/projects/new`}>
        //       {t('View New Projects')}
        //     </NavLink>
        //   ),
        // },
      ],
    },
    {
      key: 'Investments Menu',
      label: t('Investments'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'portfolio',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investments/portfolio`}>
              {t('My Investments')}
            </NavLink>
          ),
        },
        {
          key: 'opportunities',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investments/opportunities`}>
              {t('Investment Opportunities')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Validations Menu',
      label: t('Validations'),
      icon: !topMenu && <UilShield />,
      children: [
        {
          key: '10',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/validation/investment/list`}>
              {t('Investment Validations')}
            </NavLink>
          ),
        },
        {
          key: '11',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/validation/investor/${investorId}`}>
              {t('Investor Validations')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Documents',
      label: t('Documents'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'My Documents',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/documents`}>
              {t('My Documents')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Wallet Menu',
      label: t('Wallet'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'Details',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/wallet/details`}>
              {t('My Wallet')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Investor Profile',
      label: t('My Profile'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'View Profile',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/profile/view`}>
              {t('View My Profile')}
            </NavLink>
          ),
        },
        {
          key: 'Edit Profile',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/profile/edit`}>
              {t('Edit My Profile')}
            </NavLink>
          ),
        },
      ],
    },
  ];
};
